import React from 'react';
import { trademarkStats } from '../mock';
import { Award, Users, TrendingUp, Star, MapPin, Clock } from 'lucide-react';

const TrustSignals = () => {
  const achievements = [
    {
      icon: Award,
      number: trademarkStats.trademarksRegistered,
      label: "Trademarks Successfully Registered",
      description: "We have successfully filed and secured federal trademark registration for over 1,000 businesses across diverse industries, protecting their brand identities and intellectual property rights with precision and expertise."
    },
    {
      icon: TrendingUp,
      number: trademarkStats.successRate,
      label: "USPTO Approval Success Rate",
      description: "Our industry-leading 98% approval rate demonstrates our meticulous approach to trademark applications, comprehensive searches, and expert legal strategies that maximize your chances of successful registration."
    },
    {
      icon: Star,
      number: trademarkStats.clientSatisfaction,
      label: "Client Satisfaction Rating",
      description: "Based on verified client reviews and testimonials, 99% of our clients report complete satisfaction with our trademark services, professional support, and dedicated case management throughout the registration process."
    },
    {
      icon: Clock,
      number: trademarkStats.yearsExperience,
      label: "Years of Trademark Expertise",
      description: "With over 15 years of specialized experience in trademark law and USPTO procedures, our team brings deep knowledge and proven strategies to protect your brand effectively and efficiently."
    }
  ];

  return (
    <section className="trust-section" id="trust">
      <div className="section-container">
        <div className="section-header-center">
          <span className="section-label">Our Track Record</span>
          <h2 className="section-title">
            Proven Results You
            <span className="title-highlight"> Can Trust</span>
          </h2>
          <p className="section-description">
            Numbers that speak to our commitment, expertise, and success in protecting 
            brands across America. See why businesses trust us with their trademark registration.
          </p>
        </div>

        <div className="trust-grid">
          {achievements.map((achievement, index) => {
            const Icon = achievement.icon;
            return (
              <div key={index} className="trust-card">
                <div className="trust-icon">
                  <Icon size={32} />
                </div>
                <div className="trust-number">{achievement.number}</div>
                <div className="trust-label">{achievement.label}</div>
                <div className="trust-description">{achievement.description}</div>
              </div>
            );
          })}
        </div>

        {/* Trust Badges */}
        <div className="trust-badges-section">
          <h3 className="trust-badges-title">Recognized Excellence</h3>
          <div className="trust-badges">
            <div className="trust-badge-item">
              <div className="badge-icon">🏆</div>
              <div className="badge-text">
                <div className="badge-title">USPTO Filing Experts</div>
                <div className="badge-subtitle">Certified professionals</div>
              </div>
            </div>
            <div className="trust-badge-item">
              <div className="badge-icon">⚖️</div>
              <div className="badge-text">
                <div className="badge-title">Legal Excellence</div>
                <div className="badge-subtitle">Specialized trademark law</div>
              </div>
            </div>
            <div className="trust-badge-item">
              <div className="badge-icon">🔒</div>
              <div className="badge-text">
                <div className="badge-title">Secure & Confidential</div>
                <div className="badge-subtitle">Your data protected</div>
              </div>
            </div>
            <div className="trust-badge-item">
              <div className="badge-icon">✅</div>
              <div className="badge-text">
                <div className="badge-title">BBB Accredited</div>
                <div className="badge-subtitle">A+ rating</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TrustSignals;
